<template>
  <div class="DateDropDownSelect" :class="getStyle()">
    <div class="dis-block">
      <!-- 一级选择 -->
      <el-select v-model="selectValue" class="drop-down-select" placeholder="请选择" @change="onSelectChange">
        <el-option v-for="item in selectList" :key="item.label" :label="item.label" :value="item.value" />
      </el-select>
      <!-- 二级选择 -->
      <el-select
        v-if="hasChild"
        v-model="selectValue2"
        key="child"
        class="drop-down-select"
        placeholder="请选择"
        @change="onChildChange"
      >
        <el-option v-for="item in childList" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <!-- 三级选择 -->
      <el-select
        v-if="hasThird"
        v-model="selectValue3"
        key="child"
        class="drop-down-select"
        placeholder="请选择"
        @change="onThirdChange"
      >
        <el-option v-for="item in dayList" :key="item.label" :value="item.value" :label="item.label" />
      </el-select>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { getDateCompletion } from '../publicmethods_js/publicmethods';
export default {
  name: 'numberSelection',
  props: {
    numberSelectData: Array,
    selectApi: String,
  },
  data() {
    return {
      selectValue: '', // 一级
      selectValue2: '', // 二级
      selectValue3: '', // 三级
      selectList: [
        {
          label: '2025',
          value: '2025',
          modelValue: '2025',
        },
        {
          label: '2024',
          value: '2024',
          modelValue: '2024',
        },
        {
          label: '2023',
          value: '2023',
          modelValue: '2023',
        },
        {
          label: '2022',
          value: '2022',
          modelValue: '2022',
        },
      ],
      childList: [],
      hasChild: false,
      hasThird: false,
      dayList: [],
      watchNewm: '',
      watchNewy: '',
    };
  },
  computed: {
    ...mapState({
      componentName: state => state.ProjectInfo.CurrentScene.Charts,
    }),
  },
  watch: {
    componentName: {
      handler() {},
      immediate: true,
    },
    watchNewm: {
      handler(newM) {
        this.watchNewm = newM;
      },
      immediate: true,
    },
    selectValue: {
      handler(newY) {
        this.watchNewy = newY;
      },
      immediate: true,
    },
  },
  mounted() {
    // 初始化下拉数据
    if (this.selectApi.currenEntry === 'staticData') {
      this.selectValue = this.selectList[0].value;
    } else {
      this.$nextTick(() => {
        this.selectList = JSON.parse(JSON.stringify(this.numberSelectData));
        this.selectValue = this.selectList[0]?.value;

        // 处理二级、三级
        const selectedYearItem = this.selectList.find(item => item.value === this.selectValue);
        if (selectedYearItem?.children) {
          this.childList = selectedYearItem.children || [];
          this.hasChild = !!this.childList.length;

          const now = new Date();
          const currentMonth = now.getMonth() + 1;
          const currentDay = now.getDate();

          // 查找当前月份
          let selectMonth = this.childList.find(mon => currentMonth == mon.value);

          // 默认选择第一个月份
          if (!selectMonth && this.childList.length > 0) {
            selectMonth = this.childList[0];
          }

          if (selectMonth) {
            this.selectValue2 = selectMonth.value;
          }

          // 检查是否需要显示天数选择
          if (this.childList[0]?.third === 'Third') {
            // 设置当前日期，不足10补零
            this.selectValue3 = currentDay < 10 ? '0' + currentDay : currentDay.toString();

            // 更新生成天数列表所需的变量
            this.watchNewy = this.selectValue;
            this.watchNewm = this.selectValue2;

            // 生成天数列表
            this.updateDayList();
            this.hasThird = true;
          }
        }
      });
    }
  },
  methods: {
    getStyle() {
      let style = {};
      switch (this.componentName) {
        case 'V1Style':
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style['V5Style'] = true;
          break;
        case 'V11Style':
          style['V11Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    // 一级选择变化
    onSelectChange(val) {
      console.log(val, 'zzzzzzz 2222');

      this.selectValue = val;

      // 当年份变化时更新月份列表
      const selectedYearItem = this.selectList.find(item => item.value === val);
      if (selectedYearItem?.children) {
        this.childList = selectedYearItem.children || [];
        this.hasChild = !!this.childList.length;

        const now = new Date();
        const currentMonth = now.getMonth() + 1;

        // 查找当前月份
        let selectMonth = this.childList.find(mon => currentMonth == mon.value);

        // 默认选择第一个月份
        if (!selectMonth && this.childList.length > 0) {
          selectMonth = this.childList[0];
        }

        if (selectMonth) {
          this.selectValue2 = selectMonth.value;
        }

        // 更新天数列表
        if (this.hasThird) {
          this.watchNewy = val;
          this.watchNewm = this.selectValue2;
          this.updateDayList();

          // 确保选中的日期有效
          const daysInMonth = this.getDaysInMonth(this.watchNewy, this.watchNewm);
          const selectedDay = parseInt(this.selectValue3);
          if (selectedDay > daysInMonth) {
            this.selectValue3 = daysInMonth < 10 ? '0' + daysInMonth : daysInMonth.toString();
          }
        }
      }

      this.emitChange();
    },
    // 二级选择变化
    onChildChange(val) {
      console.log(val);

      this.selectValue2 = val;

      // 当月份变化时更新天数列表
      if (this.hasThird) {
        this.watchNewy = this.selectValue;
        this.watchNewm = val;
        this.updateDayList();

        // 确保选中的日期有效
        const daysInMonth = this.getDaysInMonth(this.watchNewy, this.watchNewm);
        const selectedDay = parseInt(this.selectValue3);
        if (selectedDay > daysInMonth) {
          this.selectValue3 = daysInMonth < 10 ? '0' + daysInMonth : daysInMonth.toString();
        }
      }

      this.emitChange();
    },
    // 三级选择变化
    onThirdChange(val) {
      this.selectValue3 = val;
      this.emitChange();
    },
    // 统一处理 emit
    emitChange() {
      const { selectValue, selectValue2, selectValue3, hasChild, hasThird, selectList } = this;
      // 有 key 的特殊处理
      if (selectList && selectList[0] && selectList[0].key && selectList[0].key.length > 0) {
        let endTime = getDateCompletion(selectValue, selectValue2);
        let nowTime = `${selectValue}-${selectValue2}-01`;
        let Timedata = [selectList[0].key[0], nowTime, endTime];
        this.$emit('numberChange', Timedata);
      } else if (!hasChild && !hasThird) {
        this.$emit('numberChange', selectValue);
      } else if (hasChild && !hasThird) {
        this.$emit('numberChange', `${selectValue}-${selectValue2}`);
      } else if (hasChild && hasThird) {
        this.$emit('numberChange', `${selectValue}-${selectValue2}-${selectValue3}`);
      }
    },
    // 生成天数列表
    updateDayList() {
      this.dayList = [];
      const year = this.watchNewy;
      const month = this.watchNewm;
      const days = this.getDaysInMonth(year, month);
      for (let i = 1; i <= days; i++) {
        this.dayList.push({
          label: i + '日',
          value: i < 10 ? '0' + i : '' + i,
        });
      }
    },
    getDaysInMonth(year, month) {
      month = parseInt(month, 10);
      let d = new Date(year, month, 0);
      return d.getDate();
    },
  },
};
</script>

<style lang="scss" scoped>
.DateDropDownSelect {
  position: relative;
}

.drop-down-select {
  margin-left: 4px;
}

:deep().drop-down-select .el-input__inner {
  width: 60px;
  height: 22px;
  line-height: 22px;
  padding-left: 10px;
  padding-right: 20px;
  background: none;
  border: 1px solid #148cdb;
  color: #03b8ca;
  font-size: 12px;
  position: relative;
}

:deep().el-input--small .el-input__icon {
  line-height: 22px;
}

:deep().el-input__suffix {
  right: 0;
  top: -8px;

  .el-input__suffix-inner {
    margin: 0;
  }
}

:deep().drop-down-select {
  &:nth-child(n + 2) {
    .el-input__inner {
      width: 60px;
    }
  }
}

:deep().el-select__popper.el-popper {
  background: none !important;
}

:deep().el-icon-arrow-up:before {
  color: #00f4fd;
}

.V3Style {
  :deep().drop-down-select .el-input__inner {
    width: 94px;
    height: 24px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #148cdb;
    color: #03b8ca;
    font-size: 12px;
    background: linear-gradient(to top, #0c2b67, #031639, #0c2b67);
  }

  :deep().el-icon-arrow-up:before {
    color: #1597e6;
  }
}

.V4Style {
  :deep().drop-down-select .el-input__inner {
    width: 80px;
    height: 22px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #8d77d8;
    color: #fff;
    font-size: 12px;
  }

  :deep().el-icon-arrow-up:before {
    color: #8d77d8;
  }
}

.V5Style {
  :deep().drop-down-select .el-input__inner {
    width: 80px;
    height: 22px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #03a252;
    color: #fff;
    font-size: 12px;
  }

  :deep().el-icon-arrow-up:before {
    color: #03a252;
  }
}
</style>
